// extracted by mini-css-extract-plugin
export default {"lessonCardModalContainer":"LessonCardModal_lessonCardModalContainer__5PFD8","outer":"LessonCardModal_outer__J4PNN","inner":"LessonCardModal_inner__Y014j"};